<template>
    <div class="placeholder">
      <div class="placeholder__icon">
        <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7.31543" y="7.31592" width="30.8421" height="39.6842" fill="white" stroke="#BFD2E1" stroke-width="2"/>
          <rect x="1" y="1" width="30.8421" height="39.6842" fill="white" stroke="#BFD2E1" stroke-width="2"/>
          <rect x="17.6846" y="7.5791" width="10.1053" height="2.52632" transform="rotate(90 17.6846 7.5791)" fill="#BFD2E1"/>
          <rect x="17.6846" y="20.2104" width="2.52632" height="2.52632" transform="rotate(90 17.6846 20.2104)" fill="#BFD2E1"/>
          <rect x="8" y="32" width="17" height="2" fill="#BFD2E1"/>
          <rect x="8" y="27" width="17" height="2" fill="#BFD2E1"/>
        </svg>
      </div>
      <div class="placeholder__text">
        {{ text }}
      </div>
    </div>
</template>

<script>
export default {
  name: 'app-no-records-placeholder',
  props: {
    text: {
      type: String,
      required: false,
      default: 'Записи не найдены'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.placeholder {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  min-height: 220px;
  min-width: 290px;
  border: 1px solid #BFD2E1;
  border-radius: 3px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 40px;

  &__icon {
    color: #BFD2E1;
    margin-bottom: 14px;
  }

  &__text {
    font-size: 20px;
    text-align: center;
    color: #BFD2E1;
    padding-right: 44px;
    padding-left: 44px;
  }
}
</style>
